import client from './inventory-request';
import { withStoreCreateBody, withStoreUpdateBody } from '../hooks/useStoreScope';

// Stores — proxied via EMR (/app/api/inventory/...), ORG-CODE resolves org scope.

// API: GET /inventory/stores/
export const getStores = (p) => client.get('/inventory/stores/', p);
// API: GET /inventory/stores/{id}/
export const getStore = (id) => client.get(`/inventory/stores/${id}/`);
// API: POST /inventory/stores/
export const createStore = (body) => client.post('/inventory/stores/', withStoreCreateBody(body));
// API: PATCH /inventory/stores/{id}/
export const updateStore = (id, body) => client.patch(`/inventory/stores/${id}/`, withStoreUpdateBody(body));
// API: DELETE /inventory/stores/{id}/  (soft-delete)
export const deleteStore = (id) => client.delete(`/inventory/stores/${id}/`);

// API: GET /inventory/stores/{id}/tree/
export const getStoreTree = (id) => client.get(`/inventory/stores/${id}/tree/`);

// API: GET /inventory/stores/{id}/bins/
export const getStoreBins = (storeId, p) => client.get(`/inventory/stores/${storeId}/bins/`, p);
// API: POST /inventory/stores/{id}/bins/
export const createStoreBin = (storeId, body, p) =>
  client.post(`/inventory/stores/${storeId}/bins/`, withStoreCreateBody(body), p);
// API: PATCH /inventory/bins/{id}/
export const updateStoreBin = (binId, body) =>
  client.patch(`/inventory/bins/${binId}/`, withStoreUpdateBody(body));
// API: DELETE /inventory/bins/{id}/  (soft-delete)
export const deleteStoreBin = (binId) => client.delete(`/inventory/bins/${binId}/`);

// API: GET /inventory/stores/{id}/allowed-transactions/
export const getAllowedTransactions = (storeId, p) =>
  client.get(`/inventory/stores/${storeId}/allowed-transactions/`, p);
// API: PUT /inventory/stores/{id}/allowed-transactions/  (bulk upsert)
export const upsertAllowedTransactions = (storeId, body, p) =>
  client.put(`/inventory/stores/${storeId}/allowed-transactions/`, withStoreUpdateBody(body), p);

// API: GET /inventory/stores/{id}/can/?txn_type=
export const canStorePerformTxn = (storeId, txnType, p = {}) =>
  client.get(`/inventory/stores/${storeId}/can/`, { ...p, txn_type: txnType });

// API: GET /inventory/stores/{id}/allowed-item-classes/
// Returns { store_id, is_restricted, allowed_item_class_ids }.
// is_restricted false (empty list) means the store accepts every item class.
// Writes go through updateStore() with allowed_item_class_ids.
export const getStoreAllowedItemClasses = (storeId) =>
  client.get(`/inventory/stores/${storeId}/allowed-item-classes/`);

// API: GET /inventory/stores/{id}/reorder/
export const getStoreReorder = (storeId) => client.get(`/inventory/stores/${storeId}/reorder/`);
// API: POST /inventory/stores/{id}/reorder/
export const updateStoreReorder = (storeId, body) =>
  client.post(`/inventory/stores/${storeId}/reorder/`, withStoreUpdateBody(body));
